import React from "react";
import { Route } from "react-router";

import { LoadError } from "@/mk2/components/errors/LoadError";
import { NotFoundError } from "@/mk2/components/errors/NotFoundError";

interface OwnProps {
    errorMessage: string;

    backButton?: React.ReactNode;

    onRetry?(): void;
}

export class Failure extends React.Component<OwnProps> {
    public render() {
        return (
            <Route
                render={({ staticContext }) => {
                    const { errorMessage, backButton, onRetry } = this.props;
                    if (
                        errorMessage &&
                        ["NOT FOUND", "GONE"].includes(errorMessage.toUpperCase()) &&
                        backButton
                    ) {
                        return <NotFoundError button={backButton} />;
                    } else {
                        if (staticContext && staticContext.statusCode === 200) {
                            staticContext.statusCode = 500;
                        }
                        return <LoadError onRetry={onRetry} />;
                    }
                }}
            />
        );
    }
}
